// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ay-3";
export var contentContainer = "_ay-0";
export var editorContainer = "_ay-1";
export var quillInputForm = "_ay-2";
export var zoneDivider = "_ay-4";